import format from '@/utils/formatNumber'

export default (value, options) => format.amount(value, options)
